import { render, staticRenderFns } from "./DistributorsStep.vue?vue&type=template&id=5603d4a9&scoped=true&"
import script from "./DistributorsStep.vue?vue&type=script&lang=ts&"
export * from "./DistributorsStep.vue?vue&type=script&lang=ts&"
import style0 from "./DistributorsStep.vue?vue&type=style&index=0&id=5603d4a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5603d4a9",
  null
  
)

export default component.exports